module.exports = __webpack_public_path__ + "img/pic_20.c4e9576e.gif";